export function colorWithoutOpacity(color: string) {
  const deriveHex = color.replace("#", "").split(/(?=(?:..)*$)/);
  const a = 0.6;
  // @ts-ignore
  const r = Math.floor(`0x${deriveHex[0]}` * a + 0xff * (1 - a));
  // @ts-ignore
  const g = Math.floor(`0x${deriveHex[1]}` * a + 0xff * (1 - a));
  // @ts-ignore
  const b = Math.floor(`0x${deriveHex[2]}` * a + 0xff * (1 - a));

  return "#" + ((r << 16) | (g << 8) | b).toString(16);
}

export function generateRandomColor() {
  let maxVal = 0xffffff; // 16777215
  let randomNumber = Math.random() * maxVal;
  randomNumber = Math.floor(randomNumber);
  let randColor = randomNumber.toString(16).padStart(6, "0");
  return `#${randColor.toUpperCase()}`;
}